// Segment
import { AnalyticsBrowser } from "@segment/analytics-next";

// note: we do not currently support church-specific segment on new-web.
// This should really be looked at as a deprecated feature - we want to only support core segment,
// and church-specific segments were really only used by a few megachurches (crsds and cf) on their custom apps.
export const analytics = AnalyticsBrowser.load({
  writeKey: "uXIMHrxQGDBjFlPCK0u3iAo17z1FidAF",
});
